import React from 'react';
import { Container } from 'react-bootstrap';
import '../App.css';

const Footer = () => {
    return (
        <footer className="footer bg-dark text-light mt-auto py-3">
            <Container className="text-center">
                <small>
                    &copy; {new Date().getFullYear()} Purdue Fort Wayne – Helmke Library<br />
                    <em>Built by Divya Navale.</em>
                </small>
            </Container>
        </footer>
    );
};

export default Footer;
